/* eslint-disable @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access */
import React from 'react';

import {
    AustraliaSvg,
    BordeauxSvg,
    BurgundySvg,
    CaliforniaSvg,
    ChampagneSvg,
    MoselSvg,
    PiedmontSvg,
    RhoneSvg,
    TuscanySvg,
    WalaWalaValleySvg
} from '~/assets/img/illustrations';
import { Box, Container, Flex } from '~/vinovest-design-system/components';
import { LayeredButton } from '~/vinovest-design-system/components/Button/LayeredButton';
import type { CMSTradeCountry } from '~/networking/api/cms/responses/CMSRegion';
import styles from './directory.module.scss';
import { MarketingRoutes } from '~/routes/marketing';
import { useRegionImages } from '~/components/views/Directory/useRegionImages';

interface Props {
    country: CMSTradeCountry;
}

export const RegionsDirectory: React.FC<Props> = ({ country }) => {
    const { hero } = useRegionImages();

    return (
        <>
            <div className={styles.displayWrapper}>
                <div className={styles.content}>
                    <h1 className={'heading-1'}>{country.name}</h1>
                    <LayeredButton variant={'primary'} href={MarketingRoutes.SignUp} classnames={'px-16'}>
                        Get started
                    </LayeredButton>

                    <div className={`hero hero1 ${country.slug}`}>
                        <img
                            src={hero.img1.src}
                            width={hero.img1.width}
                            height={hero.img1.height}
                            aria-hidden
                            alt={`hero left`}
                        />
                    </div>
                    <div className={`hero hero2 ${country.slug}`}>
                        <img
                            src={hero.img2.src}
                            width={hero.img2.width}
                            height={hero.img2.height}
                            aria-hidden
                            alt={`hero right`}
                        />
                    </div>
                </div>
            </div>

            <Container classnames={'mt-14 md:px-5'}>
                <h2 className={'heading-1 my-4 sm:my-3.5 text-center'}>Top wine-producing regions</h2>
                <Flex classnames={'flex-col md:flex-row flex-wrap '}>
                    {country.regions.map((region) => {
                        return (
                            <Box classnames={'relative w-full md:w-1/2 my-12'} key={region.id}>
                                <Box classnames={'max-w-sm mx-5 lg:m-auto'}>
                                    <Box classnames={styles.box}>
                                        {region.name === 'rhone' && (
                                            <Flex classnames={'justify-center'}>
                                                <RhoneSvg />
                                            </Flex>
                                        )}
                                        {region.name === 'burgundy' && (
                                            <Flex classnames={'justify-center'}>
                                                <BurgundySvg />
                                            </Flex>
                                        )}
                                        {region.name === 'bordeaux' && (
                                            <Flex classnames={'justify-center'}>
                                                <BordeauxSvg />
                                            </Flex>
                                        )}
                                        {region.name === 'champagne' && (
                                            <Flex classnames={'justify-center'}>
                                                <ChampagneSvg />
                                            </Flex>
                                        )}
                                        {region.name === 'piedmont' && (
                                            <Flex classnames={'justify-center'}>
                                                <PiedmontSvg />
                                            </Flex>
                                        )}
                                        {region.name === 'tuscany' && (
                                            <Flex classnames={'justify-center'}>
                                                <TuscanySvg />
                                            </Flex>
                                        )}
                                        {region.name === 'california' && (
                                            <Flex classnames={'justify-center'}>
                                                <CaliforniaSvg />
                                            </Flex>
                                        )}
                                        {region.name === 'walla walla valley' && (
                                            <Flex classnames={'justify-center'}>
                                                <WalaWalaValleySvg />
                                            </Flex>
                                        )}
                                        {region.name === 'mosel' && (
                                            <Flex classnames={'justify-center'}>
                                                <MoselSvg />
                                            </Flex>
                                        )}
                                        {region.name === 'south australia' && (
                                            <Flex classnames={'justify-center'}>
                                                <AustraliaSvg />
                                            </Flex>
                                        )}
                                        <h3 className={'heading-3'}>{region.displayName}</h3>
                                    </Box>
                                    <LayeredButton
                                        variant={'secondary'}
                                        href={`/trade/${country.slug}/${region.slug}`}
                                        classnames={'w-full'}
                                    >
                                        Learn More
                                    </LayeredButton>
                                </Box>
                            </Box>
                        );
                    })}
                </Flex>
            </Container>
        </>
    );
};
